import * as React from 'react';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var IconShoppingBag_12 = function IconShoppingBag_12(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H21.3337C21.7479 11.25 22.0837 11.5858 22.0837 12V30.5719C22.0837 30.9861 21.7479 31.3219 21.3337 31.3219H5C4.58579 31.3219 4.25 30.9861 4.25 30.5719V12ZM5.75 12.75V29.8219H20.5837V12.75H5.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8219 16.2856C20.8219 15.8714 21.1577 15.5356 21.5719 15.5356H27.0482C27.3323 15.5356 27.592 15.6961 27.7191 15.9502L30.4645 21.4411L33.0981 22.7579C33.3522 22.8849 33.5127 23.1446 33.5127 23.4287V30.5717C33.5127 30.9859 33.1769 31.3217 32.7627 31.3217H21.0957C20.6815 31.3217 20.3457 30.9859 20.3457 30.5717C20.3457 30.1575 20.6815 29.8217 21.0957 29.8217H32.0127V23.8922L29.57 22.6709C29.4249 22.5983 29.3072 22.4806 29.2346 22.3355L26.5847 17.0356H21.5719C21.1577 17.0356 20.8219 16.6999 20.8219 16.2856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0941 30.5717C13.0941 31.8867 12.028 32.9527 10.713 32.9527C9.39805 32.9527 8.33203 31.8867 8.33203 30.5717C8.33203 29.2567 9.39805 28.1907 10.713 28.1907C12.028 28.1907 13.0941 29.2567 13.0941 30.5717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.713 28.9407C9.81226 28.9407 9.08203 29.6709 9.08203 30.5717C9.08203 31.4725 9.81226 32.2027 10.713 32.2027C11.6138 32.2027 12.3441 31.4725 12.3441 30.5717C12.3441 29.6709 11.6138 28.9407 10.713 28.9407ZM7.58203 30.5717C7.58203 28.8425 8.98383 27.4407 10.713 27.4407C12.4423 27.4407 13.8441 28.8425 13.8441 30.5717C13.8441 32.3009 12.4423 33.7027 10.713 33.7027C8.98383 33.7027 7.58203 32.3009 7.58203 30.5717Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.43 30.5717C29.43 31.8867 28.364 32.9527 27.049 32.9527C25.734 32.9527 24.668 31.8867 24.668 30.5717C24.668 29.2567 25.734 28.1907 27.049 28.1907C28.364 28.1907 29.43 29.2567 29.43 30.5717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.049 28.9407C26.1482 28.9407 25.418 29.6709 25.418 30.5717C25.418 31.4725 26.1482 32.2027 27.049 32.2027C27.9498 32.2027 28.68 31.4725 28.68 30.5717C28.68 29.6709 27.9498 28.9407 27.049 28.9407ZM23.918 30.5717C23.918 28.8425 25.3198 27.4407 27.049 27.4407C28.7782 27.4407 30.18 28.8425 30.18 30.5717C30.18 32.3009 28.7782 33.7027 27.049 33.7027C25.3198 33.7027 23.918 32.3009 23.918 30.5717Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.75C16.5 17.0302 13.0302 20.5 8.75 20.5C4.46979 20.5 1 17.0302 1 12.75C1 8.46979 4.46979 5 8.75 5C13.0302 5 16.5 8.46979 16.5 12.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86474 16.375H7.47896V9.25052H6.06403L4.41992 10.4163V11.7914L5.86474 10.8448V16.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11332 16.375H13.494V15.1494H10.724L12.0691 13.8341C12.8962 13.037 13.4442 12.2597 13.4442 11.3131C13.4442 10.0277 12.5474 9.15088 10.9731 9.15088C9.37879 9.15088 8.38236 10.0477 8.30265 11.6918H9.7674C9.877 10.7551 10.2756 10.3865 10.9033 10.3865C11.5211 10.3865 11.8499 10.7651 11.8499 11.353C11.8499 12.0007 11.4115 12.6284 10.724 13.3558L8.11332 16.1159V16.375Z",
    fill: "white"
  }));
};

export { IconShoppingBag_12 };